import Resource from '@/services/resources/common';

// question type
export default class DiagnosticTypeResource extends Resource {
  constructor(entrypoint = '/diagnostic_types', alias = 'DiagnosticType') {
    super(entrypoint, alias);
  }
}
